var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BidAwardRevokeReasonService } from '@freelancer/bid-award-revoke-reason-service';
import { Datastore, } from '@freelancer/datastore';
import { ModalRef } from '@freelancer/ui';
import { BannerAlertType } from '@freelancer/ui/banner-alert';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { HeadingSize, HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import { maxLength, required } from '@freelancer/ui/validators';
import { map, take, withLatestFrom } from 'rxjs/operators';
var RevokeModalError;
(function (RevokeModalError) {
    RevokeModalError[RevokeModalError["REVOKE_FAILED"] = 0] = "REVOKE_FAILED";
    RevokeModalError[RevokeModalError["REVOKE_REASON_FAILED"] = 1] = "REVOKE_REASON_FAILED";
})(RevokeModalError || (RevokeModalError = {}));
var BidAwardRevokeModalComponent = /** @class */ (function () {
    function BidAwardRevokeModalComponent(datastore, modalRef, fb, revokeReasonService) {
        this.datastore = datastore;
        this.modalRef = modalRef;
        this.fb = fb;
        this.revokeReasonService = revokeReasonService;
        this.ButtonColor = ButtonColor;
        this.ButtonSize = ButtonSize;
        this.HeadingType = HeadingType;
        this.HeadingSize = HeadingSize;
        this.Margin = Margin;
        this.BannerAlertType = BannerAlertType;
        this.RevokeModalError = RevokeModalError;
        this.OTHER_REASON = 'Other';
        this.MAX_OTHER_REASON_LEN = 100;
        this._isRevoked = false;
    }
    BidAwardRevokeModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.formGroup = this.fb.group({
            reason: ['', [required('Please choose a revoke reason')]],
            otherReason: [
                {
                    value: '',
                    disabled: true,
                },
                [
                    required('Please enter revoke reason'),
                    maxLength(100, 'Please enter at most 100 characters'),
                ],
            ],
        });
        var revokeReaons$ = this.datastore
            .collection('bidAwardRevokeReasons')
            .valueChanges();
        this.revokeReasonMap$ = revokeReaons$.pipe(map(function (reasons) {
            return reasons.reduce(function (acc, reason) {
                acc[reason.reason] = reason.id;
                return acc;
            }, {});
        }));
        this.revokeReasonOptions$ = revokeReaons$.pipe(map(function (reasons) { return reasons.map(function (reason) { return reason.reason; }); }));
        this.bidDocument = this.datastore.document('bids', this.bidId);
        this._reasonChangeSub = this.formGroup.controls.reason.valueChanges.subscribe(function (reasonRadioValue) {
            if (reasonRadioValue === _this.OTHER_REASON) {
                _this.formGroup.controls.otherReason.enable();
            }
            else {
                _this.formGroup.controls.otherReason.disable();
            }
        });
    };
    BidAwardRevokeModalComponent.prototype.ngOnDestroy = function () {
        this._reasonChangeSub.unsubscribe();
    };
    BidAwardRevokeModalComponent.prototype.handleGoBack = function () {
        this.modalRef.close();
    };
    /**
     *
     * Two separate API calls
     * 1. Revoke the bid award
     * 2. Save the revoke reason
     *
     * The first request is more important, so we only send the second request
     * if the first one is successful.
     *
     */
    BidAwardRevokeModalComponent.prototype.handleRevokeAward = function () {
        var _this = this;
        // allow employer to only re-submit revoke reason if the request failed
        if (this._isRevoked) {
            this.submissionPromise = this.bidDocument
                .valueChanges()
                .pipe(take(1), withLatestFrom(this.revokeReasonMap$))
                .toPromise()
                .then(function (_a) {
                var bid = _a[0], reasonMap = _a[1];
                return _this.createBidAwardRevokeReasonRecord(bid, _this.formGroup, reasonMap);
            })
                .then(function (bidRevokeReasonResponse) {
                if (bidRevokeReasonResponse.status === 'error') {
                    return __assign({ errorType: RevokeModalError.REVOKE_REASON_FAILED }, bidRevokeReasonResponse);
                }
                _this.modalRef.close();
                return bidRevokeReasonResponse;
            });
        }
        else {
            var reasonMap_1;
            var bid_1;
            this.submissionPromise = this.bidDocument
                .valueChanges()
                .pipe(take(1), withLatestFrom(this.revokeReasonMap$))
                .toPromise()
                .then(function (_a) {
                var bidTemp = _a[0], reasonMapTemp = _a[1];
                reasonMap_1 = reasonMapTemp;
                bid_1 = bidTemp;
                return _this.bidDocument.update({
                    awardStatus: "revoked" /* REVOKED */,
                });
            })
                .then(function (bidRevokeResponse) {
                if (bidRevokeResponse.status === 'error') {
                    return __assign({ errorType: RevokeModalError.REVOKE_FAILED }, bidRevokeResponse);
                }
                _this._isRevoked = true;
                return _this.createBidAwardRevokeReasonRecord(bid_1, _this.formGroup, reasonMap_1);
            })
                .then(function (bidRevokeReasonResponse) {
                if (bidRevokeReasonResponse.status === 'error') {
                    return __assign({ errorType: RevokeModalError.REVOKE_REASON_FAILED }, bidRevokeReasonResponse);
                }
                _this.modalRef.close();
                return bidRevokeReasonResponse;
            });
        }
    };
    BidAwardRevokeModalComponent.prototype.createBidAwardRevokeReasonRecord = function (bid, formGroup, reasonMap) {
        var reasonId = reasonMap[formGroup.controls.reason.value];
        var otherFeedback = formGroup.controls.reason.value === this.OTHER_REASON
            ? formGroup.controls.otherReason.value
            : '';
        return this.revokeReasonService.saveBidAwardRevokeReason({
            projectId: bid.projectId,
            freelancerId: bid.bidderId,
            reasonId: reasonId,
            otherFeedback: otherFeedback,
        });
    };
    return BidAwardRevokeModalComponent;
}());
export { BidAwardRevokeModalComponent };
